/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const TrendIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M12.963 2.302a.75.75 0 0 0-1.071-.136 9.74 9.74 0 0 0-3.539 6.176 7.6 7.6 0 0 1-1.705-1.715.75.75 0 0 0-1.152-.082A9 9 0 1 0 15.68 4.55a7.46 7.46 0 0 1-2.717-2.248m2.787 11.964a3.75 3.75 0 1 1-7.313-1.172c.628.464 1.35.81 2.133 1a6 6 0 0 1 1.925-3.546 3.75 3.75 0 0 1 3.255 3.718" clipRule="evenodd" /></svg>;
};
export default TrendIcon;